import { Navigate } from "react-router-dom";

/**
 * Every v1 admin takeover URL (the list, its create form and its edit form, all
 * under this prefix) lands on the v2 list. A v1 id means nothing to v2 — the
 * old records were not migrated (spec §7) — so no path is kept.
 */
export const LEGACY_TAKEOVER_ROUTE =
	"/admin/vendor-sponsorship/full-screen-takeover/*";

export const LegacyTakeoverRedirect = () => (
	<Navigate to="/admin/takeovers" replace />
);
